import { render, staticRenderFns } from "./PendingList.vue?vue&type=template&id=80c8a724"
import script from "./PendingList.vue?vue&type=script&lang=js"
export * from "./PendingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports